import type { ReactNode } from 'react';
import type { To } from 'react-router';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { IconButton } from '@sorare/core/src/atoms/buttons/IconButton';
import { ChevronRightBold } from '@sorare/core/src/atoms/icons/ChevronRightBold';
import { SBHorizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { HeadlineM } from '@sorare/core/src/atoms/typography';
import { useIsLaptop } from '@sorare/core/src/hooks/device/useIsLaptop';

type Props = {
  title: ReactNode;
  button?: {
    label: ReactNode;
    to: To;
    onClick?: () => void;
  };
};

export const HeaderSection = ({ title, button }: Props) => {
  const isLaptop = useIsLaptop();
  const { label, to, onClick } = button || {};
  return (
    <SBHorizontal>
      <Vertical gap={0.5}>
        <HeadlineM>{title}</HeadlineM>
      </Vertical>

      {!!label && !!to && (
        <>
          {isLaptop ? (
            <Button to={to} size="small" color="tertiary" onClick={onClick}>
              {label}
            </Button>
          ) : (
            <IconButton to={to} size="small" color="tertiary" onClick={onClick}>
              <ChevronRightBold />
            </IconButton>
          )}
        </>
      )}
    </SBHorizontal>
  );
};
